import {
  BEAUTY_PRIMARY_CATEGORY,
  ENTERTAINMENT_PRIMARY_CATEGORY,
  FASHION_PRIMARY_CATEGORY,
  FOOD_DRINKS_PRIMARY_CATEGORY,
  GLOBAL_NEWS_PRIMARY_CATEGORY,
  LIVING_PRIMARY_CATEGORY,
  POLITICS_PRIMARY_CATEGORY,
  WELLNESS_PRIMARY_CATEGORY
} from '../../constants';
import {get} from 'lodash';

export const getArticleTag = (primary_category) => {
  const isFoodCategory = get(primary_category, 'name') === FOOD_DRINKS_PRIMARY_CATEGORY;
  const isVertical = get(primary_category, 'parent.is_root');

  /*
   * Uses the primary category name for verticals or "Food & Drinks"
   * Uses the parent category name for subverticals
   */
  const categoryName = isVertical || isFoodCategory
    ? get(primary_category, 'name')
    : get(primary_category, 'parent.name');

  switch(categoryName) {
    case BEAUTY_PRIMARY_CATEGORY: return 'beauty';
    case ENTERTAINMENT_PRIMARY_CATEGORY: return 'entertainment';
    case FASHION_PRIMARY_CATEGORY: return 'style';
    case FOOD_DRINKS_PRIMARY_CATEGORY: return 'food';
    case GLOBAL_NEWS_PRIMARY_CATEGORY: return 'news';
    case LIVING_PRIMARY_CATEGORY: return 'work_money';
    case POLITICS_PRIMARY_CATEGORY: return 'news';
    case WELLNESS_PRIMARY_CATEGORY: return 'health';
    default: return '';
  }
};
